import React from "react";

const TicketsTableHeader = ({
  headers,
  sortConfig,
  onSort,
  headerClassName,
  tableStyle,
}) => {
  return (
    <thead>
      <tr>
        {headers.map(({ key, label, sortable }) => (
          <th
            key={key}
            className={`py-3 px-4 font-bold text-gray-500 text-xs font-ubuntu tracking-wider ${
              key === "action" || key === "status" ? "text-center" : "text-left"
            } border-b border-gray-100 ${headerClassName} ${
              sortable ? "cursor-pointer hover:bg-gray-50" : ""
            }`}
            onClick={sortable ? () => onSort(key) : undefined}
            aria-sort={
              sortConfig.key === key ? sortConfig.direction : undefined
            }
            style={tableStyle}
          >
            {label}{" "}
            {sortConfig.key === key
              ? sortConfig.direction === "asc"
                ? "↑"
                : "↓"
              : ""}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TicketsTableHeader;
